<template>
  <div>
    <div v-if="abstract && authors">
      <h3 class="text-center mb-3" v-if="previewMode()">Preview</h3>
      <div class="row alert alert-info d-print-none" v-if="previewMode()">
        <div class="col-3 d-flex">
          <icon :icon="['fal', 'file-pdf']" class="text-info fa-5x my-auto"/>
        </div>
        <div class="col">
          <div class="row">
            <div class="col text-success">
              <h5>
                <Speaker :submission_id="abstract.setting_submission_id" area="submit"
                         textkey="pdf_download_title"></Speaker>
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <Speaker :submission_id="abstract.setting_submission_id" area="submit"
                       textkey="pdf_download_text"></Speaker>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col d-flex">
              <button class="btn btn-success" v-if="processing.pdf === false" v-on:click="GET_PDF($route.params.id)">
                <icon :icon="['fad', 'download']" class="mx-auto my-auto"/>
                {{ wording[0].buttons.download }}
              </button>
              <ProcessingButton v-else></ProcessingButton>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!previewMode()">
        <div v-if="validation.is_checked === false">
          <div v-if="makeValidation()"></div>
        </div>
        <div class="col"
             v-if="(validation.is_checked === true && validation.status === false) || (authorvalidation.is_checked === true && authorvalidation.status === false) || (settings.authors.min_authors > authors.length)">
          <div class="alert alert-danger">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation-circle']" class="fa-3x mx-auto my-auto"/>
              </div>
              <div class="col-8 d-flex">
                <div class="row my-auto">
                  <div class="col d-flex">
                    <h5 class="my-auto">
                      <Speaker :submission_id="abstract.setting_submission_id" area="submit"
                               textkey="submission_not_complete"></Speaker>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col"
             v-if="(validation.is_checked === true && validation.status === true) && (authorvalidation.is_checked === true && authorvalidation.status === true)  && ( settings.authors.min_authors <= authors.length)">
          <div class="alert alert-success">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'check']" class="fa-3x mx-auto my-auto"/>
              </div>
              <div class="col-8 d-flex">
                <div class="row my-auto">
                  <div class="col d-flex">
                    <h5 class="my-auto">
                      <Speaker :submission_id="abstract.setting_submission_id" area="submit"
                               textkey="submission_complete"></Speaker>
                    </h5>
                  </div>
                  <button type="button" class="btn btn-success" v-if="validation.status === true"
                          v-on:click="submit();">
                    {{ wording[0].buttons.submit }}
                    <icon :icon="['fad', 'paper-plane']"/>
                  </button>
                  <ProcessingButton class="mr-auto" v-else-if="processing.submit"></ProcessingButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Object.keys(settings).includes('payment') && settings.payment === true">
        <payment_status :abstract_id="abstract.id" @abstract_paid="makeValidation()"></payment_status>
      </div>
      <div v-if="authors && settings.xcheck">
        <div class="row" v-if="settings.xcheck.presenter">
          <div class="col" v-if="rulexvalue > settings.xcheck.countGreaterThen">
            <div class="alert alert-info">
              <div class="row">
                <div class="col-1 d-flex">
                  <icon :icon="['fad', 'exclamation-circle']" class="fa-3x mx-auto my-auto"/>
                </div>
                <div class="col-8">
                  <div class="row my-auto">
                    <div class="col d-flex my-auto">
                      <Speaker :submission_id="abstract.setting_submission_id" area="submit"
                               textkey="rulex_check_presenter"></Speaker>
                    </div>
                  </div>
                  <div class="row mt-1" v-if="presenterAbstracts"
                       v-for="(presAbstract,presAbstractIndex) in presenterAbstracts" v-bind:key="presAbstractIndex">
                    <div class="col">{{ presAbstract.reference_number }}</div>
                    <div class="col">{{ presAbstract.title }}</div>
                    <div class="col">{{ presAbstract.lastname }}, {{ presAbstract.firstname }}</div>
                    <div class="col">{{ presAbstract.email }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row previewRow">
        <div class="col col-3 previewKey font-weight-bold">{{ wording[abstract.setting_submission_id].submit.form_reference }}:
        </div>
        <div class="col col-md-8">{{ abstract.reference_number }}</div>
      </div>

      <div v-bind:class="{ 'alert alert-danger': validation.errors.title}"
           v-if="settings.submit.showTitle && settings.submit.showTitle === true">
        <div class="row previewRow">
          <div class="col col-3 previewKey font-weight-bold">{{ wording[abstract.setting_submission_id].submit.form_title }}:
          </div>
          <div class="col col-md-8" v-html="abstract.title"></div>
        </div>
      </div>
      <!--
            <div class="row previewRow" v-if="settings.abstracttable.showtype">
              <div class="col col-3 previewKey font-weight-bold">Type:
              </div>
              <div class="col col-md-8"><span v-for="type in types" v-if="abstract.type_id === type.id">{{ type.name }}</span>
              </div>
            </div>
      -->
      <div v-if="!settings.authors.disabled">
        <div
            v-bind:class="{ 'alert alert-danger': (authorvalidation.is_checked === true && authorvalidation.status === false) || (settings.authors.min_authors > authors.length)}">
          <div class="row previewRow">
            <div class="col-3 previewKey font-weight-bold">
              {{ _[abstract.setting_submission_id].submit.titel_authors }}:
            </div>
            <div class="col">
              <author-preview/>
              <div class="alert alert-danger" v-if="validationPresentation.length > 0">{{ validationPresentation }}
              </div>
            </div>
          </div>
        </div>

        <div class="row d-print-none" v-if="!previewMode()">
          <div class="col">
            <button class="btn btn-info btn-sm" v-on:click="$router.push('authors')">
              <icon :icon="['fad', 'backward']"/>&nbsp;{{ wording[0].buttons.back_to }}
              {{ getCurrentPages(abstract.setting_submission_id).find(page => page.setting_page_type_id === 2).menu_name }}
            </button>
          </div>
        </div>
      </div>
      <div v-for="(page, index) in getCurrentPages(abstract.setting_submission_id)" class="mt-3">
        <!--      Dynamische Formulare-->
        <div class="row" v-if="page.setting_page_type_id === 1 && page.entity">
          <div class="col">
            <entitegenerator :entities="page.entity" :values="abstract"
                             :system="{main: 'submission', action: 'submit'}"
                             :models="{'theme_list':theme_list,
                             'countries':countryData(),
                             'region':datahelper.region,
                             'methods_topic': datahelper.methods_topic,
                             'disease_topic': datahelper.disease_topic,
                             'care_cascade_topic': datahelper.care_cascade_topic,
                             'call_proposal': datahelper.call_proposal,
                             'agerange':datahelper.agerange,
                             'gender':gender,
                             'salutation': salutation,
                             'slot_room_capacity_sat':datahelper.slot_room_capacity_sat,
                             'sat_pres_date':datahelper.sat_pres_date,
                             'duration_5': datahelper.duration_5,
                             'duration_6': datahelper.duration_6,
                             'duration_7': datahelper.duration_7,
                             'scholar_main_interest':datahelper.scholar_main_interest,
                             'scholar_professional_category':datahelper.scholar_professional_category,
                             'scholar_involved_programme':datahelper.scholar_involved_programme,
                             'scholar_conference_participation':datahelper.scholar_conference_participation,
                             'scholar_type':datahelper.scholar_type,
                             'scholar_assistence':datahelper.scholar_assistence,
                             'methods_used': datahelper.methods_used,
                             'room_setup': datahelper.room_setup,
                             'session_type': datahelper.session_type
                              }"
                             :error="validation.errors" mode="preview"></entitegenerator>
          </div>
        </div>
        <div class="row d-print-none" v-if="page.setting_page_type_id === 1 && page.entity && previewMode() === false">
          <div class="col">
            <button class="btn btn-info btn-sm" v-on:click="$router.push('dynamic/' + page.id)">
              <icon :icon="['fad', 'backward']"/>&nbsp;{{ wording[0].buttons.back_to }} {{ page.menu_name }}
            </button>
          </div>
        </div>
      </div>
      <!--      Confirmation Entities (Chair 1, Chair 2, etc.)-->
      <div class="mt-3" v-if="confirmEntities && Object.keys(confirmEntities).length > 0">
        <div class="row">
          <div class="col">
            <entitegenerator :entities="confirmEntities" :values="abstract"
                             :system="{main: 'submission', action: 'submit'}"
                             :models="{'gender':gender,'salutation':salutation}"
                             :error="validation.errors" mode="preview"></entitegenerator>
          </div>
        </div>
        <div class="row d-print-none" v-if="previewMode() === false">
          <div class="col">
            <button class="btn btn-info btn-sm" v-on:click="$router.push('confirm')">
              <icon :icon="['fad', 'backward']"/>&nbsp;{{ wording[0].buttons.back_to }} Confirmation
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-if="!previewMode()">
        <div class="col d-flex">
          <router-link
              :to="previousSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(this.abstract.setting_submission_id,3).id)"
              class="mr-auto btn btn-info" tag="button">
            <icon :icon="['fas', 'angle-left']"/>
            {{ wording[0].buttons.back }}
          </router-link>
          <span class="ml-auto">
            <button type="button" class="btn btn-success"
                    v-if="validation.status === true && authorvalidation.is_checked === true && authorvalidation.status === true"
                    v-on:click="submit();">
              {{ wording[0].buttons.submit }}
              <icon :icon="['fad', 'paper-plane']"/>
            </button>
          <ProcessingButton class="mr-auto" v-else-if="processing.submit"></ProcessingButton>
            <button type="button" class="btn btn-success disabled pointer-no" disabled v-else>
              <icon :icon="['fad', 'file-signature']"/> {{ wording[0].buttons.submit }}
            </button>
          </span>
        </div>
      </div>
      <div class="row mt-4" v-else>
        <div class="col d-flex">
          <router-link :to="'/home'"
                       class="mr-auto btn btn-info" tag="button">
            <icon :icon="['fas', 'angle-left']"/>
            {{ wording[0].buttons.back }}
          </router-link>
        </div>
      </div>
    </div>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
import entitegenerator from 'entite-generator';
import AuthorPreview from '../author/AuthorPreview'
import payment_status from "@/components/payment/payment_status";
import VueScrollTo from "vue-scrollto";

export default {
  data() {
    return {
      presenterAbstracts: []
    };
  },
  computed: {
    ...mapState([
      'abstract', 'authors', 'theme_list', 'validation', 'wording', 'processing', 'authorvalidation', 'datahelper', 'settings', 'rulexvalue', 'types', "language", 'gender', 'salutation'
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType', 'getPresenter', "isOpen", 'getConfirmEntities'
    ]),
    confirmEntities: function () {
      if (this.abstract && this.abstract.setting_submission_id) {
        return this.getConfirmEntities(Number(this.abstract.setting_submission_id));
      }
      return {};
    },
  },
  data() {
    return {
      validationPresentation: '',
    };
  },
  components: {
    payment_status,
    AuthorPreview, entitegenerator
  },
  methods: {
    previewMode() {
      if (this.isOpen(this.abstract.setting_submission_id) === false) {
        return true;
      } else if (this.$route.name === 'preview' || this.abstract.edited === true || this.abstract.status_id === 2) {
        return true;
      }
      return false;
    },
    async ruleXCheck() {
      this.processing.rulex = true;
      let target = 'xcheck/presenter';
      let presenter = this.authors.find(author => author.role_id === 2);
      if (!presenter) return 0;
      let template = {
        "firstname": presenter.firstname,
        "lastname": presenter.lastname,
        "email": presenter.email,
        "setting_submission_id": [this.abstract.setting_submission_id]
      };
      this.VALIDATE_TARGET({
        template: template,
        target: target
      }).then((result) => {
        this.processing.rulex = false;
        this.$store.commit('SET_RULEXVALUE', {"rulex": result.data});
        if (this.rulexvalue > this.settings.xcheck.countGreaterThen) {
          this.PRESENTER_ABSTRACTS({template: template}).then((resultPA) => {
            this.presenterAbstracts = resultPA.data;
            this.processing.rulex = false;
          }).catch((error) => {
            this.processing.rulex = false;
          });
        }
        return result.data;
      }).catch((error) => {
        this.processing.rulex = false;
      });
      return 0;
    },
    async submit() {
      this.processing.submit = true;
      let submitting = false;
      if (this.validation.is_checked === false) {
        this.processing.submit = false;
        return false;
      }
      await this.SUBMIT_ABSTRACT(this.$route.params.id).then((result) => {
        submitting = true;
      })
      if (submitting === false) {
        return false;
      }
      await this.GET_ONE_ABSTRACT(this.$route.params.id).then((response) => {
        this.$store.dispatch('IMPLODE_ADDITIONAL_ABSTRACT_DATA', response.data);
        this.$router.push('submitsuccess');
        this.processing.submit = false;
      });
    },
    makeValidation() {
      if (this.settings.authors.disabled === true) {
        this.$store.dispatch('VALIDATE');
        this.validation.is_checked = true;
        this.authorvalidation.is_checked = true;
        this.authorvalidation.status = true;
        //console.log('author dis')
        return true;
      }

      this.authorvalidation.status = true;
      this.validation.is_checked = true;
      this.processing.validation = true;
      this.authorvalidation.errors = [];
      let author_error = false;
      this.$store.dispatch('VALIDATE');
      this.ruleXCheck();
      let presenter = this.authors.filter(author => author.role_id === 2);
      if (presenter.length === 0) {
        this.authorvalidation.is_checked = true;
        this.authorvalidation.status = false;
      }
      //SPECIAL UNION 2020 SESSION VALIDIERUNG
      let presentations = {};
      if (this.abstract.setting_submission_id === 2 || this.abstract.setting_submission_id === 3) {
        this.authors.forEach((element, index) => {
          let presentation = element.additional_content.presentation_title.toLowerCase();
          if (!this.containsKey(presentations, presentation)) {
            presentations[presentation] = 0;
          }
          presentations[presentation]++;
        });
        let minPresentations = 0;
        let maxPresentations = 5;
        switch (this.abstract.type_id) {
          case 3: {
            minPresentations = 4;
            maxPresentations = 5;
            break;
          }
          case 4: {
            minPresentations = 4;
            maxPresentations = 5;
            break;
          }
          case 5: {
            minPresentations = 4;
            maxPresentations = 5;
            if(this.abstract['content__duration_5'] == 47){
              maxPresentations = 10
            }

            break;
          }
          case 6: {
            minPresentations = 4;
            maxPresentations = 5;
            if(this.abstract['content__duration_6'] == 49){
              maxPresentations = 10
            }
            break;
          }
          case 7: {
            minPresentations = 1;
            maxPresentations = 5;
            break;
          }
        }
        //console.log(Object.keys(presentations).length);
        //console.log(minPresentations);
        //console.log(maxPresentations);
        //console.log(this.authorvalidation.status);
        if (Object.keys(presentations).length > maxPresentations) {
          this.authorvalidation.is_checked = true;
          this.authorvalidation.status = false;
          this.validationPresentation = 'Too many presentations entered. Maximum: ' + maxPresentations;
        }
        if (Object.keys(presentations).length < minPresentations) {
          this.authorvalidation.is_checked = true;
          this.authorvalidation.status = false;
          this.validationPresentation = 'Not enough presentations entered. At least: ' + minPresentations + ' presentations with different presentation titles.';
        }
      }
      //--SPECIAL UNION 2020
      this.authors.forEach((author, index) => {
            this.authorvalidation.is_checked = true;
            //this.authorvalidation.status = true;
            if (!author.institute || author.institute.length === 0) {
              this.authorvalidation.is_checked = true;
              this.authorvalidation.status = false;
              this.authorvalidation.errors.push({
                'author_id': author.id,
                'error': this._[this.abstract.setting_submission_id].author_overview.non_exist_institute
              });
            }
            //SPECIAL UNION 2020 SESSION VALIDIERUNG
            if (this.abstract.setting_submission_id === 2 || this.abstract.setting_submission_id === 3) {
              if (presentations[author.additional_content.presentation_title.toLowerCase()] >= 2) {
                this.authorvalidation.is_checked = true;
                this.authorvalidation.status = false;
                this.authorvalidation.errors.push({
                  'author_id': author.id,
                  'error': 'The presentation has reached the speaker limit.'
                });
              }
            }
            //--SPECIAL UNION 2020
            let target = this.abstract.setting_submission_id + '/';
            target += author.role_id === 2 ? 'presenter/author' : 'coauthor/author';
            let additionalKey = 'additional_content';
            let author_implode = {};
            Object.assign(author_implode, author);
            if (Object.keys(author_implode).includes(additionalKey)) {
              let additionals = author_implode[additionalKey];
              delete author_implode[additionalKey];
              for (let itemkey in additionals) {
                author_implode[additionalKey + '__' + itemkey] = additionals[itemkey];
              }
            }
            this.VALIDATE_TARGET({
              template: author_implode,
              target: target
            }).then((result) => {
            }).catch((error) => {
              this.authorvalidation.errors.push({'author_id': author_implode.id, 'error': error.response.data});
              this.authorvalidation.is_checked = true;
              this.authorvalidation.status = false;
              author_error = true;
            })
          }
      );
      this.processing.validation = false;
    },
    ...mapActions([
      'PUT_SUBMIT', 'VALIDATE', 'PUT_ABSTRACT', 'SUBMIT_ABSTRACT', 'VALIDATE_TARGET', "PRESENTER_ABSTRACTS", "GET_ONE_ABSTRACT", "GET_PDF"
    ]),
    ...mapMutations([
      'SET_AUTHOR_VALIDATION'
    ])
  },
  created() {
    VueScrollTo.scrollTo('#top', 100, {easing: 'ease-in'});
    this.validation.is_checked = false;
    this.processing.validation = false;
  }
}
</script>
<style lang="css">
/*Vordefinierte CSS Klassen innerhalb der Preview Funktion des EntityGenerator*/
/*Für die Zeile*/
.previewRow {
}

/*Fragen Links*/
.previewKey {
  margin-top: 5px;
}

/*Antworten Rechts*/
.previewValue {
}

</style>
